var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M832 341.333333v149.333334h-128v-149.333334h-42.666667v149.333334h-128v-149.333334h-42.666666v149.333334h-149.333334v42.666666h149.333334v128h-149.333334v42.666667h149.333334v128h-149.333334v42.666667h533.333334V341.333333h-42.666667z m0 192v128h-128v-128h128z m-298.666667 0h128v128h-128v-128z m0 170.666667h128v128h-128v-128z m170.666667 128v-128h128v128h-128z",
    fill: "#0d1821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.333333 170.666667H170.666667v682.666666h170.666666V341.333333h512z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.333333 149.333333v725.333334h213.333334V362.666667h512V149.333333H149.333333z m42.666667 341.333334v-128h128v128H192z m128 42.666666v128H192v-128h128z m42.666667-341.333333h128v128h-128V192z m170.666666 0h128v128h-128V192zM320 192v128H192V192h128zM192 832v-128h128v128H192z m640-512h-128V192h128v128z",
    fill: "#a8ffba"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt);
export default __webpack_public_path__ + "static/media/ct.b13976126b7a24ca1faaec1116758ae1.svg";
export { ForwardRef as ReactComponent };